(() => {
  const storagePrefix = 'sakura:list-scroll:';
  const storageKey = `${storagePrefix}${window.location.pathname}${window.location.search}`;
  const maximumAge = 30 * 60 * 1000;
  let userInterrupted = false;

  function savePosition() {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify({ y: window.scrollY, savedAt: Date.now() }));
    } catch (error) {
      // Native history restoration remains the fallback when storage is unavailable.
    }
  }

  function readPosition() {
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(storageKey));
      if (!Number.isFinite(saved?.y) || !Number.isFinite(saved?.savedAt) || Date.now() - saved.savedAt > maximumAge) return null;
      return Math.max(0, saved.y);
    } catch (error) {
      return null;
    }
  }

  function hasSavedCollectionPages() {
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(`sakura:collection-pages:${window.location.pathname}${window.location.search}`));
      return Number.isInteger(saved?.page) && saved.page > 1 && Number.isFinite(saved.savedAt) && Date.now() - saved.savedAt <= maximumAge;
    } catch (error) {
      return false;
    }
  }

  function isProductLink(link) {
    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && /^\/products\//.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function restorePosition(y) {
    [0, 100, 350, 800].forEach((delay) => {
      window.setTimeout(() => {
        if (userInterrupted) return;
        const maximumScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo({ top: Math.min(y, maximumScroll), left: 0, behavior: 'instant' });
      }, delay);
    });
  }

  function restoreAfterCollectionPages(y) {
    let finished = false;
    const restore = () => {
      if (finished) return;
      finished = true;
      document.removeEventListener('sakura:collection:pages-restored', restore);
      restorePosition(y);
    };
    if (document.documentElement.dataset.sakuraPagesRestored === 'true') {
      restore();
      return;
    }
    document.addEventListener('sakura:collection:pages-restored', restore, { once: true });
    window.setTimeout(restore, 2500);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (link && isProductLink(link)) savePosition();
  }, true);
  window.addEventListener('pagehide', savePosition);

  ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, () => { userInterrupted = true; }, { passive: true });
  });

  window.addEventListener('pageshow', (event) => {
    userInterrupted = false;
    const navigation = window.performance.getEntriesByType?.('navigation')?.[0];
    if (!event.persisted && navigation?.type !== 'back_forward') return;
    const savedPosition = readPosition();
    if (savedPosition !== null) {
      if (document.querySelector('[data-sakura-collection-grid]') && hasSavedCollectionPages()) {
        restoreAfterCollectionPages(savedPosition);
      } else {
        restorePosition(savedPosition);
      }
    }
  });
})();
